import { LOGIN_USER, REMOVE_TOKEN, REMOVE_USER, SET_NOTIFICATION_FLAG, SET_TOKEN } from "../types";

const initialState = {
    user: null,
    isAuthenticated: false,
    token: null,
    showNotification: false
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_USER: {
            return {
                ...state,
                user: action.user,
                isAuthenticated: true
            }
        }
        case REMOVE_USER: {
            return {
                ...state,
                user: null,
                isAuthenticated: false
            }
        }
        case SET_TOKEN: {
            // console.log("Action Payload: ", action.payload)
            return {
                ...state,
                token: action.payload
            }
        }
        case REMOVE_TOKEN: {
            return {
                ...state,
                token: null
            }
        }
        case SET_NOTIFICATION_FLAG: {
            return {
                ...state,
                showNotification: action.payload
            }
        }

        default: {
            return state
        }
    }
}
export default reducer